import React from "react";
import { bool, func, string } from "prop-types";

import * as S from "./styled";

const SuccessModal = props => (
  <S.UIModal
    isOpen={props.isOpen}
    onRequestClose={props.onRequestClose}
    rootElementId={props.rootElementId}
  >
    <S.StyledXButton onClick={props.onRequestClose} />
    <S.Content>
      <div>
        <S.StyledTitle type="primarySm">
          You’ve claimed {props.address}!
        </S.StyledTitle>
        <ul>
          <li>
            <S.CheckMark />
            You will be dislpayed on the listing as the buyer’s agent
          </li>
          <li>
            <S.CheckMark />
            Your profile will be updated to include this deal
          </li>
        </ul>
      </div>
    </S.Content>
  </S.UIModal>
);

SuccessModal.propTypes = {
  address: string.isRequired,
  isOpen: bool.isRequired,
  onRequestClose: func.isRequired,
  rootElementId: string.isRequired
};

export default SuccessModal;
